const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/locations/$locationId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import type { UpdateLocationRequest } from "@/types/api/location";
import { createFileRoute } from "@tanstack/react-router";
import * as z from "zod";
export const Route = createFileRoute("/client/locations/$locationId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
const locationSchema = z.object({
  locationName: z.string().min(1, "Location Name is required"),
  description: z.string().optional(),
  address1: z.string().min(1, "Address Line 1 is required"),
  address2: z.string().optional(),
  city: z.string().min(1, "City is required"),
  state: z.string().min(1, "State is required"),
  postalCode: z.string().min(1, "Postal Code is required"),
  country: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().email("Invalid email").optional().or(z.literal("")),
  timeZoneId: z.string().optional(),
  isMainLocation: z.boolean(),
  isActive: z.boolean()
});
type LocationFormValues = z.infer<typeof locationSchema>;